import { parseCsv } from './csv';
import type { ComplianceImportOptions, ImportRegister, ImportResult } from './types';
import { validateRegister } from './validate';

export * from './registers';
export * from './types';

/**
 * Prepare a browser-selected CSV for staging. `today` must already be a
 * tenant-local ISO business date; this pure library never reads the clock.
 */
export function prepareComplianceImport(
  text: string,
  register: ImportRegister,
  today: string,
  options: ComplianceImportOptions = {},
): ImportResult {
  const csv = parseCsv(text.charCodeAt(0) === 0xfeff ? text.slice(1) : text, {
    byteLength: options.byteLength ?? new TextEncoder().encode(text).byteLength,
  });
  if (!Array.isArray(csv)) return csv;
  const { rows, unknownColumns } = validateRegister(csv, register, today);
  return {
    ok: true,
    batch: {
      register,
      rows,
      summary: {
        total: rows.length,
        ok: rows.filter((row) => row.status === 'OK').length,
        warning: rows.filter((row) => row.status === 'WARNING').length,
        error: rows.filter((row) => row.status === 'ERROR').length,
        unknownColumns,
      },
    },
  };
}
